import { Controller } from "@hotwired/stimulus"

// Controller to auto-calculate calories based on grams using a calories-per-gram ratio
export default class extends Controller {
  static targets = ["gramsField", "caloriesField"]

  static values = {
    ratio: Number // calories per gram
  }

  connect() {
    // Ensure initial values are set correctly on page load
    this.calculate()
  }

  calculate() {
    if (!this.hasGramsFieldTarget || !this.hasCaloriesFieldTarget) return

    const grams = parseFloat(this.gramsFieldTarget.value) || 0
    const ratio = this.ratioValue || 0

    // Calculate calories: grams * calories_per_gram
    const calories = Math.round(grams * ratio)

    this.caloriesFieldTarget.value = calories
  }
}
